/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Not_PublishedInputs */

const cs_enum_not_published = /** @type {(inputs: Enum_Not_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepublikováno`)
};

const en_enum_not_published = /** @type {(inputs: Enum_Not_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not published`)
};

/**
* | output |
* | --- |
* | "Not published" |
*
* @param {Enum_Not_PublishedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_not_published = /** @type {((inputs?: Enum_Not_PublishedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Not_PublishedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_not_published(inputs)
	return cs_enum_not_published(inputs)
});